"use client";

import { useState } from "react";
import type { BlogFrontmatter } from "@/lib/types";
import HeroSection from "./HeroSection";
import Blogs from "./Blogs";
import StrategySection from "../common/StrategySection";
import { WA_NUMBERS } from "@/lib/consultation-links";

type Props = {
  posts: BlogFrontmatter[];
  calendlyUrl: string;
};

export default function BlogsPageClient({ posts, calendlyUrl }: Props) {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <>
      <HeroSection searchQuery={searchQuery} onSearchChange={setSearchQuery} />
      <Blogs posts={posts} searchQuery={searchQuery} />
      <StrategySection
        title="Get the latest Updates"
        descriptionWidthClass="w-[781px]"
        description="Missing one filing can trigger penalties. Missing several can risk strike-off. Most founders choose a compliance partner so they never have to track deadlines manually again."
        buttons={[
          {
            text: "Book Your Free Strategy Call",
            variant: "primary",
            href: calendlyUrl || "#",
          },
          { text: "Chat With Us On WhatsApp", variant: "secondary" },
        ]}
        note="No obligation | 30-minute consultation | Tailored to your situation"
        whatsappNumbers={WA_NUMBERS}
      />
    </>
  );
}
